import React, { lazy, Suspense, useEffect } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { StickyCTA } from './components/ui/StickyCTA';
import { initMetaPixel } from './utils/metaPixel';

// Everything below the hero is code-split into its own chunk and loaded right
// after the initial paint — none of it is needed to render the first screen,
// so it shouldn't compete with the hero/LCP for the browser's main thread.
const SocialProof = lazy(() => import('./components/sections/SocialProof').then(mod => ({
  default: mod.SocialProof
})));
const Differentiators = lazy(() => import('./components/sections/Differentiators').then(mod => ({
  default: mod.Differentiators
})));
const Transformation = lazy(() => import('./components/sections/Transformation').then(mod => ({
  default: mod.Transformation
})));
const Method = lazy(() => import('./components/sections/Method').then(mod => ({
  default: mod.Method
})));
const ForYou = lazy(() => import('./components/sections/ForYou').then(mod => ({
  default: mod.ForYou
})));
const WhatYouGet = lazy(() => import('./components/sections/WhatYouGet').then(mod => ({
  default: mod.WhatYouGet
})));
const ProductGallery = lazy(() => import('./components/sections/ProductGallery').then(mod => ({
  default: mod.ProductGallery
})));
const InstantAccess = lazy(() => import('./components/sections/InstantAccess').then(mod => ({
  default: mod.InstantAccess
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const AboutAuthor = lazy(() => import('./components/sections/AboutAuthor').then(mod => ({
  default: mod.AboutAuthor
})));
const Pricing = lazy(() => import('./components/sections/Pricing').then(mod => ({
  default: mod.Pricing
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="83i1pfjpjqra">
      <div className="w-full min-h-full bg-white font-body text-gris-texto" data-id="element-1" data-mp="3gkv1ltuzrtec">
        <main data-id="element-2" data-mp="3bmbg1ukb8jmi">
          <Hero data-id="element-3" data-mp="3bmtij8xkfu2v" />
          <Suspense fallback={null} data-id="element-4" data-mp="3bncqbwti5236">
            <SocialProof data-id="element-5" data-mp="3bk702e94zu5v" />
            <Differentiators data-id="element-6" data-mp="3qb7lrkyw9kjy" />
            <Transformation data-id="element-7" data-mp="3qc96yi9mjnfe" />
            <Method data-id="element-8" data-mp="3qciln9p7y85s" />
            <ForYou data-id="element-9" data-mp="3qd0tl3l8uatj" />
            <WhatYouGet data-id="element-10" data-mp="3lkr2vlcb16q7" />
            <ProductGallery data-id="element-11" data-mp="3ljg1fs6c0b29" />
            <InstantAccess data-id="element-12" data-mp="3lj6bu5p785x3" />
            <Testimonials data-id="element-13" data-mp="2xuwtjdr720ap" />
            <AboutAuthor data-id="element-14" data-mp="2xu3ii0l7comr" />
            <Pricing data-id="element-15" data-mp="2xtby7lx22dbs" />
            <Guarantee data-id="element-16" data-mp="2xssf41vo5iw6" />
            <FAQ data-id="element-17" data-mp="2sw207hvlotcc" />
            <FinalCTA data-id="element-18" data-mp="2swlkv6cmxvu2" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-19" data-mp="2stzcx5lu1ebb">
          <Footer data-id="element-20" data-mp="18d9haio8i6xz" />
        </Suspense>
        <StickyCTA data-id="element-21" data-mp="18c6kxv857cao" />
      </div>
    </LazyMotion>;
}